export default __webpack_public_path__ + "static/media/press-10.829fa33f.jpg";